import React, { Suspense, lazy } from 'react'
const App = lazy(() => import('@!/App/containers/App'))
import { BaseProvider } from '@!/providers'

export const AppProvider = (props) => {
  return (
    <BaseProvider {...props}>
      <Suspense fallback={null}>
        <App {...props}>{props.children}</App>
      </Suspense>
    </BaseProvider>
  )
}
